import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const Canteen = () => {
  useEffect(() => {
    document.title = "Canteen -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Facilities</li>
          <li> Other Facilities</li>
          <li>Canteen</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Canteen </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                {" "}
                The school has a canteen which caters to the requirements of
                staff and students. It provides a wide range of items of
                refreshment at reasonable rates.
              </p>
            </div>
            <div className="col-lg-12">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Canteen.png"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Canteen.png"
                    className="mx-auto d-block schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Canteen;
